import {register} from 'dna-react-ioc'
import {
    CompanyDetailsStore,
    CompanyDetailsStoreSymbol,
    ICompanyDetailsStore
} from '@/stores/company-details'

export const companyDetailsState = () => {
    register<ICompanyDetailsStore>(CompanyDetailsStoreSymbol)
        .to(CompanyDetailsStore)
        .inSingletonScope()
}